// import Header from "./components/Header";
import classes from "./App.module.css";
import Timer from "./components/Timer";
import { useSelector } from "react-redux";
import clsx from "clsx";

function App() {
  const mode = useSelector((state) => state.timer.mode);

  return (
    <div className={clsx(classes.container, classes[mode])}>
		<div class="pomodoro-breeze-logo"><a href="https://www.breeze.pm"><img src="https://d1wdkw032nxkks.cloudfront.net/2019/breeze_logo_white.svg" alt="Breeze logo" width="300" height="64" /></a></div>
		
      <div className={classes.content}>
        <Timer />
      </div>
    </div>
  );
}

export default App;
